<div class="border border-outline dark:border-outline-darkmode rounded-lg overflow-hidden">
  <app-supplier-contract-check-item
    [data]="data().CHECK_OVERALL_COST"
    [organizationId]="organizationId()"
    class="block"
  >
    <h4 slot="title">{{ 'cockpit.supplierContracts.check.overallCost.title' | transloco }}</h4>
    <span slot="subtitle">
      {{ 'cockpit.supplierContracts.check.overallCost.subtitle' | transloco }}
    </span>
  </app-supplier-contract-check-item>
  <app-supplier-contract-check-item
    [organizationId]="organizationId()"
    [data]="data().CHECK_PRICE_CONSUMPTION_MATCH"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <h4 slot="title">
      {{ 'cockpit.supplierContracts.check.priceConsumptionMatch.title' | transloco }}
    </h4>
    <span slot="subtitle">
      {{ 'cockpit.supplierContracts.check.priceConsumptionMatch.subtitle' | transloco }}
    </span>
  </app-supplier-contract-check-item>
  <app-supplier-contract-check-item
    [organizationId]="organizationId()"
    [data]="data().CHECK_FIX_COST"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <h4 slot="title">{{ 'cockpit.supplierContracts.check.fixCost.title' | transloco }}</h4>
    <span slot="subtitle">
      {{ 'cockpit.supplierContracts.check.fixCost.subtitle' | transloco }}
    </span>
  </app-supplier-contract-check-item>
  <app-supplier-contract-check-item
    [organizationId]="organizationId()"
    [data]="data().CHECK_INDEX_PRICE_DEPENDENCY"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <h4 slot="title">
      {{ 'cockpit.supplierContracts.check.indexPriceDependency.title' | transloco }}
    </h4>
    <span slot="subtitle">
      {{ 'cockpit.supplierContracts.check.indexPriceDependency.subtitle' | transloco }}
    </span>
  </app-supplier-contract-check-item>
  <app-supplier-contract-check-item
    [data]="data().CHECK_TRANCHE_TIMING_PERFORMANCE"
    [organizationId]="organizationId()"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <h4 slot="title">
      {{ 'cockpit.supplierContracts.check.trancheTimingPerformance.title' | transloco }}
    </h4>
    <span slot="subtitle">
      {{ 'cockpit.supplierContracts.check.trancheTimingPerformance.subtitle' | transloco }}
    </span>
  </app-supplier-contract-check-item>
  <app-supplier-contract-check-item
    [data]="data().CHECK_CONSUMPTION_FLEXIBILITY"
    [organizationId]="organizationId()"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <h4 slot="title">
      {{ 'cockpit.supplierContracts.check.consumptionFlexibility.title' | transloco }}
    </h4>
    <span slot="subtitle">
      {{ 'cockpit.supplierContracts.check.consumptionFlexibility.subtitle' | transloco }}
    </span>
  </app-supplier-contract-check-item>
  <app-supplier-contract-check-item
    [data]="data().CHECK_MARGIN_TRANSPARENCY"
    [organizationId]="organizationId()"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <h4 slot="title">
      {{ 'cockpit.supplierContracts.check.marginTransparency.title' | transloco }}
    </h4>
    <span slot="subtitle">
      {{ 'cockpit.supplierContracts.check.marginTransparency.subtitle' | transloco }}
    </span>
  </app-supplier-contract-check-item>
  <app-supplier-contract-check-item
    [data]="data().CHECK_PRICING_BILLING_COMPLEXITY"
    [organizationId]="organizationId()"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <h4 slot="title">
      {{ 'cockpit.supplierContracts.check.pricingBillingComplexity.title' | transloco }}
    </h4>
    <span slot="subtitle">
      {{ 'cockpit.supplierContracts.check.pricingBillingComplexity.subtitle' | transloco }}
    </span>
  </app-supplier-contract-check-item>
  <app-supplier-contract-check-item
    [data]="data().CHECK_FIX_PRICE_GUARANTEE"
    [organizationId]="organizationId()"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <h4 slot="title">
      {{ 'cockpit.supplierContracts.check.fixPriceGuarantee.title' | transloco }}
    </h4>
    <span slot="subtitle">
      {{ 'cockpit.supplierContracts.check.fixPriceGuarantee.subtitle' | transloco }}
    </span>
  </app-supplier-contract-check-item>
  <app-supplier-contract-check-item
    [data]="data().CHECK_DECISION_MAKING_EFFORT"
    [organizationId]="organizationId()"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <h4 slot="title">
      {{ 'cockpit.supplierContracts.check.decisionMakingEffort.title' | transloco }}
    </h4>
    <span slot="subtitle">
      {{ 'cockpit.supplierContracts.check.decisionMakingEffort.subtitle' | transloco }}
    </span>
  </app-supplier-contract-check-item>
  <app-supplier-contract-check-item
    [data]="data().CHECK_CONTRACT_FLEXIBILITY"
    [organizationId]="organizationId()"
    class="block border-t border-outline dark:border-outline-darkmode"
  >
    <h4 slot="title">
      {{ 'cockpit.supplierContracts.check.contractFlexibility.title' | transloco }}
    </h4>
    <span slot="subtitle">
      {{ 'cockpit.supplierContracts.check.contractFlexibility.subtitle' | transloco }}
    </span>
  </app-supplier-contract-check-item>
</div>
